import { createSelector } from '@ngrx/store';
import { AppState } from 'src/store/appstate';

const selectMutations = (state: AppState) => state.mutations;

export const selectMutationByOperationId = (operationId: string) =>
  createSelector(selectMutations, (mutations) => mutations.get(operationId));
